import { useQuery } from "@tanstack/react-query";
import { userApi } from "../../service/client";
import { queryClient } from "../libs/react-query";
import { User } from "../model/user";

export const userQueryKey = "user-me";

export const useUserController = ({
  ignoreException = false,
}: { ignoreException?: boolean } = {}) => {
  const { data: user, isLoading } = useQuery({
    queryKey: [userQueryKey],
    queryFn: async () => {
      try {
        const response = await userApi.getMe();
        return response ?? null;
      } catch (error) {
        if (ignoreException) {
          return null;
        }

        throw error;
      }
    },
  });

  const patch = async (user: Partial<User>) => {
    await userApi.patch(user);
    queryClient.invalidateQueries({ queryKey: [userQueryKey] });
  };

  const newPicture = async (file: File) => {
    try {
      const formData = new FormData();

      formData.append("file", file);

      await userApi.uploadPicture(formData);

      queryClient.invalidateQueries({ queryKey: [userQueryKey] });
    } catch (error) {
      console.error(error);
    }
  };

  return {
    user,
    isLoading,
    patch: patch,
    newPicture: newPicture,
  };
};
